import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=d7ad7a48&scoped=true&"
import script from "./DashboardWidget.vue?vue&type=script&lang=ts&"
export * from "./DashboardWidget.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=d7ad7a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ad7a48",
  null
  
)

export default component.exports